import { useState } from 'react';
import { AxiosPrivate } from '../utils/axios';
import { ResponseException } from '../models';
import { PaginationQuery } from '../interfaces/paginationQuery.interface';

export const useGetTopics = () => {
  const [isFetchingTopics, setFetchingTopics] = useState(false);
  const [topicsErrors, setTopicsErrors] = useState<string[]>([]);

  const getReviewTopics = async id => {
    try {
      setFetchingTopics(true);
      const response = await AxiosPrivate.get(`/reviews/${id}/topics`);
      return response;
    } catch (e) {
      setTopicsErrors(new ResponseException(e).getErrorMessage());
    } finally {
      setFetchingTopics(false);
    }
  };

  const getAllTopics = async (query: PaginationQuery = {}) => {
    try {
      setFetchingTopics(true);
      const response = await AxiosPrivate.get(`/topics`, { params: { ...query } });
      return response;
    } catch (e) {
      setTopicsErrors(new ResponseException(e).getErrorMessage());
    } finally {
      setFetchingTopics(false);
    }
  };

  const getReviewTopic = async (reviewTopicId: string) => {
    try {
      setFetchingTopics(true);
      const res = await AxiosPrivate.get(`/topics/${reviewTopicId}`);
      return res;
    } catch (e) {
      setTopicsErrors(new ResponseException(e).getErrorMessage());
    } finally {
      setFetchingTopics(false);
    }
  };

  return {
    isFetchingTopics,
    topicsErrors,
    getAllTopics,
    getReviewTopics,
    getReviewTopic,
  };
};
